import { auth } from '../../constants/firebaseModular';

export const getUserDomainDiscount = async (uid: string) => {
  // RETRIEVE EXISTING DOMAIN DISCOUNT FOR A SPECIFIC USER
  const url = `${import.meta.env.VITE_CLOUDFUNCTIONS_URI}/api/discountCodes/${uid}`;
  const token = await auth.currentUser?.getIdToken();
  if (!token) {
    throw new Error('User is not authenticated');
  }

  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const res = await fetch(url, {
    method: 'GET',
    headers: myHeaders,
  });

  const data = await res.json();

  if (res.status !== 200) {
    // DO NOT INTERRUPT USER WITH THIS MESSAGE. IF A DISCOUNT DOESN'T EXIST, BUT SHOULD; IT WILL BE CREATED AUTOMATICALLY IN THE CALLER FUNCTION
    // alert(`ERROR: ${data.message}`);
  }

  return data;
};
